var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { formatListValue } from '@/shared/components/FormattedListValue';
import PopoverStickOnHover from '@/shared/components/PopoverStickOnHover';
import { CommentIcon, PaperclipIcon } from '@/shared/components/Icons';
import { useCreateTaskTimeRegistration, } from '@/shared/hooks/task/registration/useCreateTaskTimeRegistration';
import { defaultItemType, getTaskColor, states, TaskStatus, Method, } from '@/modules/tasks/taskboard/kanban/constants';
import authService, { functionalities, privileges } from '@/shared/services/AuthService';
import taskMessages from '@/modules/tasks/taskMessages';
import EditableUserSearch from '@/shared/components/editable/EditableUserSearch';
import { useDataContext } from '@/shared/providers/DataProvider';
import { useUpdateAssignedUser } from '@/shared/hooks/task/useUpdateAssignedUser';
import { useGetPlannedTaskRemark } from '@/shared/hooks/task/useGetPlannedTaskRemark';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import { useUpdateTaskStatus } from '@/shared/hooks/task/useUpdateTaskStatus';
import { useTaskTimerContext } from '@/shared/providers/TaskTimerProvider';
import { useDeletePlannedTask } from '@/shared/hooks/task/useDeletePlannedTask';
import { useGetTaskAttachments } from '@/shared/hooks/task/useGetTaskAttachments';
import EditableDatePicker from '@/shared/components/editable/EditableDatePicker';
import ToastrService from '@/shared/services/ToastrService';
import appMessages from '@/shared/messages/appMessages';
import { useUpdateTaskDeadline } from '@/shared/hooks/task/useUpdateTaskDeadline';
import FormattedDateShort from '@/shared/components/FormattedDateShort';
import TaskDropdownButton from './TaskDropdownButton';
import { getUser } from '../helper';
import TaskAttachmentsPopover from '../../../TaskAttachmentsPopover';
import { useGetTaskDocumentation } from '@/shared/hooks/task/useGetTaskDocumentation';
import dompurify from 'dompurify';
import AuthService from '@/shared/services/AuthService';
import { useHasTaskflowBilling } from '@/shared/providers/TaskflowBillingProvider';
var sanitizer = dompurify.sanitize;
var extracted = function (shareItem, subTask, toggleBlockItem, toggleInapplicable, toggleRejected, deleteItem, state, intl) {
    var canUpdateTask = AuthService.hasPermission({
        functionality: functionalities.PlannedTask,
        privilege: privileges.Update,
    });
    var menuItems = [
        {
            title: intl.formatMessage(taskMessages.Share),
            icon: _jsx("i", { className: "fa fa-fw fa-share-alt" }),
            onSelect: function () {
                shareItem(subTask);
            },
        },
        canUpdateTask &&
            !subTask.isBlocked &&
            state.status !== 2 && {
            title: intl.formatMessage(taskMessages.Block),
            icon: (_jsxs("span", __assign({ className: "fa-stack fa-sm" }, { children: [_jsx("i", { className: "fa fa-fw fa-circle fa-stack-2x fa-inverse" }), _jsx("i", { className: "fa fa-fw fa-minus-circle fa-stack-2x text-danger" })] }))),
            onSelect: function () {
                toggleBlockItem(subTask);
            },
        },
        canUpdateTask &&
            subTask.isBlocked && {
            title: intl.formatMessage(taskMessages.Unblock),
            icon: (_jsxs("span", __assign({ className: "fa-stack fa-sm" }, { children: [_jsx("i", { className: "fa fa-fw fa-circle fa-stack-2x text-primary" }), _jsx("i", { className: "fa fa-fw fa-arrow-up fa-stack-1x fa-inverse", style: { top: '-1px', left: '-0.5px' } })] }))),
            onSelect: function () {
                toggleBlockItem(subTask);
            },
        },
        canUpdateTask &&
            !subTask.inapplicable && {
            title: intl.formatMessage(taskMessages.MarkAsInapplicable),
            icon: _jsx("i", { className: "fa fa-fw fa-user-times" }),
            onSelect: function () {
                toggleInapplicable(subTask);
            },
        },
        canUpdateTask &&
            subTask.inapplicable && {
            title: intl.formatMessage(taskMessages.MarkAsApplicable),
            icon: _jsx("i", { className: "fa fa-fw fa-check-circle text-primary" }),
            onSelect: function () {
                toggleInapplicable(subTask);
            },
        },
        canUpdateTask &&
            !subTask.rejected && {
            title: intl.formatMessage(taskMessages.MarkAsRejected),
            icon: _jsx("i", { className: "fa fa-fw fa-ban" }),
            onSelect: function () {
                toggleRejected(subTask);
            },
        },
        canUpdateTask &&
            subTask.rejected && {
            title: intl.formatMessage(taskMessages.MarkAsNotRejected),
            icon: _jsx("i", { className: "fa fa-fw fa-check-circle text-primary" }),
            onSelect: function () {
                toggleRejected(subTask);
            },
        },
        AuthService.hasPermission({
            functionality: functionalities.PlannedTask,
            privilege: privileges.Delete,
        }) && {
            title: intl.formatMessage(taskMessages.Delete),
            icon: (_jsx("span", __assign({ className: "fa-stack fa-sm" }, { children: _jsx("i", { className: "fa fa-trash-o fa-fw fa-stack-2x" }) }))),
            onSelect: function () {
                deleteItem(subTask);
            },
        },
    ];
    return menuItems.filter(function (f) { return !!f; });
};
var SubTaskComponent = function (_a) {
    var _b, _c, _d;
    var task = _a.task, subTask = _a.subTask, shareItem = _a.shareItem, openTaskDetails = _a.openTaskDetails, reloadColumns = _a.reloadColumns, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, isDragging = _a.isDragging;
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var users = useDataContext().users;
    var updateAssignedUser = useUpdateAssignedUser().updateAssignedUser;
    var updateTaskStatus = useUpdateTaskStatus().updateTaskStatus;
    var deletePlannedTask = useDeletePlannedTask().deletePlannedTask;
    var updateTaskDeadline = useUpdateTaskDeadline().updateTaskDeadline;
    var hasTaskflowBilling = useHasTaskflowBilling(task === null || task === void 0 ? void 0 : task.invoiceScheduleId, subTask === null || subTask === void 0 ? void 0 : subTask.templateId);
    var _f = useTaskTimerContext(), startStopTimer = _f.startStopTimer, isTimerRunningForSubTaskId = _f.isTimerRunningForSubTaskId, processTimeRegistrationResult = _f.processTimeRegistrationResult;
    var intl = useIntl();
    var createTaskTimeRegistration = useCreateTaskTimeRegistration().createTaskTimeRegistration;
    var _g = useState(false), loadDocumentation = _g[0], setLoadDocumentation = _g[1];
    var _h = useState(false), loadRemark = _h[0], setLoadRemark = _h[1];
    var _j = useState(false), loadAttachments = _j[0], setLoadAttachments = _j[1];
    var _k = useGetPlannedTaskRemark(subTask.id, 1, false, loadRemark), remark = _k.data, loadingRemark = _k.isLoading;
    var _l = useGetTaskDocumentation(subTask.templateId, loadDocumentation), documentation = _l.data, loadingDocumentation = _l.isLoading;
    var _m = useGetTaskAttachments(subTask.id, 1, loadAttachments), attachments = _m.data, loadingAttachments = _m.isLoading;
    var isTimerRunning = useMemo(function () { return isTimerRunningForSubTaskId === subTask.id; }, [
        subTask.id,
        isTimerRunningForSubTaskId,
    ]);
    var defaultCompany = useDataContext().defaultCompany;
    var retrieveRemark = function () {
        setLoadRemark(true);
    };
    var retrieveDocumentation = function () {
        setLoadDocumentation(true);
    };
    var retrieveAttachments = function () {
        setLoadAttachments(true);
    };
    var openTimeRegistrationDialog = function (s) {
        s.relation = task.relation;
        s.mainTaskId = task.id;
        s.mainTemplateId = task.templateId;
        s.assignmentTemplateId = task.assignmentTemplateId;
        setShowModalInfo({ modalType: ModalType.TimeRegistration, task: s });
    };
    var openMailDialog = function (s) {
        setShowModalInfo({
            modalType: ModalType.TaskMail,
            task: s,
            onSave: function () { return __awaiter(void 0, void 0, void 0, function () {
                var taskTimeRegistration, timeRegistrationResult;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, updateTaskStatus({
                                id: s.id,
                                status: TaskStatus.Done,
                                isBlocked: s.isBlocked,
                                inapplicable: s.inapplicable,
                                rejected: s.rejected,
                            })];
                        case 1:
                            _a.sent();
                            if (!(defaultCompany.taskTimeRegistrationMethod === Method.AutomaticRegistration)) return [3 /*break*/, 6];
                            if (!(s.defaultDuration && s.defaultDuration > 0)) return [3 /*break*/, 4];
                            taskTimeRegistration = {
                                plannedTaskId: s.id,
                                plannedTaskTemplateId: s.templateId,
                                plannedTaskName: s.name,
                                invoiceStreamId: s.invoiceStreamId,
                                relationId: s.relationId,
                                resourceId: s.resourceId,
                                durationMinutes: s.defaultDuration,
                                mainPlannedTaskId: task.id,
                                mainTaskTemplateId: task.templateId,
                                mainPlannedTaskName: task.name,
                            };
                            return [4 /*yield*/, createTaskTimeRegistration(taskTimeRegistration)];
                        case 2:
                            timeRegistrationResult = _a.sent();
                            return [4 /*yield*/, processTimeRegistrationResult(timeRegistrationResult)];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            ToastrService.info(intl.formatMessage(appMessages.msgNoRegistrationMadeDefaultTimeZero));
                            _a.label = 5;
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            if (defaultCompany.taskTimeRegistrationMethod === Method.OpenFormOnDone) {
                                openTimeRegistrationDialog(s);
                            }
                            _a.label = 7;
                        case 7:
                            reloadColumns();
                            return [2 /*return*/];
                    }
                });
            }); },
        });
    };
    var onStartStopTimer = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!isDisabled) return [3 /*break*/, 2];
                    return [4 /*yield*/, startStopTimer(task, subTask)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var state = states[subTask.status];
    var getTaskTypeIcon = function () {
        switch (subTask.type) {
            case 0:
                return _jsx("i", { className: "fa fa-user task-type-icon", style: { fontSize: '16px' } });
            case 1:
                return _jsx("i", { className: "fa fa-hourglass task-type-icon" });
            case 2:
                return (_jsx("i", { className: "fa fa-question task-type-icon", title: intl.formatMessage(taskMessages.TimeRegistrationIsNotPossibleTaskTypeCondition) }));
            case 3:
                if (state.status <= 1) {
                    return (_jsx("i", { className: "fa fa-envelope action-icon task-type-icon clickable", onClick: function () { return !isDisabled && openMailDialog(subTask); }, title: intl.formatMessage(taskMessages.SendMail) }));
                }
                if (state.status === 2) {
                    return (_jsx("a", __assign({ onClick: function () { return openTaskDetails(subTask); }, title: intl.formatMessage(taskMessages.OpenMailHistory) }, { children: _jsx("i", { className: "fa fa-envelope" }) })));
                }
                return null;
            case 4:
                if (state.status <= 1) {
                    return (_jsxs("span", __assign({ onClick: function () { return !isDisabled && openMailDialog(subTask); }, title: intl.formatMessage(taskMessages.AutomaticMailTooltip), className: "fa-stack fa-sm action-icon task-type-icon clickable" }, { children: [_jsx("i", { className: "fa fa-calendar fa-stack-2x text-blue" }), _jsx("i", { className: "fa fa-envelope fa-stack-15x ", style: { left: '2px', top: '5px' } })] })));
                }
                if (state.status === 2) {
                    return (_jsx("a", __assign({ onClick: function () { return openTaskDetails(subTask); }, title: intl.formatMessage(taskMessages.OpenMailHistory) }, { children: _jsx("i", { className: "fa fa-envelope" }) })));
                }
                return null;
            default:
                return null;
        }
    };
    var toggleBlockItem = useCallback(function (s) {
        updateTaskStatus({
            id: s.id,
            status: s.status,
            isBlocked: !s.isBlocked,
            inapplicable: s.inapplicable,
            rejected: s.rejected,
        });
    }, [updateTaskStatus]);
    var toggleInapplicable = useCallback(function (s) {
        updateTaskStatus({
            id: s.id,
            status: s.status,
            isBlocked: s.isBlocked,
            inapplicable: !s.inapplicable,
            rejected: s.rejected,
        });
    }, [updateTaskStatus]);
    var toggleRejected = useCallback(function (s) {
        updateTaskStatus({
            id: s.id,
            status: s.status,
            isBlocked: s.isBlocked,
            inapplicable: s.inapplicable,
            rejected: !s.rejected,
        });
    }, [updateTaskStatus]);
    var onDeleteTask = useCallback(function (s) {
        setShowModalInfo({
            modalType: ModalType.YesNo,
            title: intl.formatMessage(taskMessages.DeleteTask),
            message: intl.formatMessage(taskMessages.DeleteTaskConfirmationMsg),
            onSave: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    deletePlannedTask({ taskId: s.id, taskLevel: s.taskLevel });
                    return [2 /*return*/];
                });
            }); },
        });
    }, [setShowModalInfo, deletePlannedTask, intl]);
    var menuItems = useMemo(function () {
        return extracted(shareItem, subTask, toggleBlockItem, toggleInapplicable, toggleRejected, onDeleteTask, state, intl);
    }, [
        shareItem,
        subTask,
        toggleBlockItem,
        toggleInapplicable,
        toggleRejected,
        onDeleteTask,
        state,
        intl,
    ]);
    var selectedUser = getUser((_b = subTask.userId) !== null && _b !== void 0 ? _b : task.userId, users);
    var canUpdateTask = useMemo(function () {
        return authService.hasPermission({
            functionality: functionalities.PlannedTask,
            privilege: privileges.Update,
        });
    }, []);
    var taskColor = getTaskColor(subTask);
    var remarkPopover = (_jsxs("span", __assign({ id: "popover-trigger-hover-focus" }, { children: [loadingRemark ? _jsx("i", { className: "fa fa-spin fa-spinner" }) : null, _jsx("span", __assign({ style: { whiteSpace: 'pre-line' } }, { children: remark === null || remark === void 0 ? void 0 : remark.remark }))] })));
    var documentationPopover = (_jsxs("span", __assign({ id: "popover-trigger-hover-focus" }, { children: [loadingDocumentation ? _jsx("i", { className: "fa fa-spin fa-spinner" }) : null, _jsx("div", { dangerouslySetInnerHTML: { __html: sanitizer(documentation === null || documentation === void 0 ? void 0 : documentation.documentation) } })] })));
    var showTimerRunning = useMemo(function () { return defaultCompany.taskTimeRegistrationMethod === 2 && isTimerRunning; }, [defaultCompany.taskTimeRegistrationMethod, isTimerRunning]);
    var onChangeUser = function (user) {
        var _a;
        var userId = (_a = user === null || user === void 0 ? void 0 : user.id) !== null && _a !== void 0 ? _a : null;
        updateAssignedUser({
            taskId: subTask.id,
            userId: userId,
            taskLevel: subTask.taskLevel,
        });
    };
    var onUpdateDeadline = function (deadline) {
        updateTaskDeadline({
            id: subTask.id,
            deadline: deadline || null,
            taskLevel: subTask.taskLevel,
        });
    };
    return (_jsx("div", __assign({ className: "dskb-item-container", id: "task_".concat(subTask.id) }, { children: _jsxs("div", __assign({ className: "dskb-item-element", style: {
                backgroundColor: taskColor.backgroundColor,
            } }, { children: [_jsx("div", { className: classNames({ 'tr-running-n': showTimerRunning }) }), _jsx("div", { className: "dskb-gripper", style: {
                        backgroundColor: (_c = taskColor.color) !== null && _c !== void 0 ? _c : defaultItemType.color,
                    } }), _jsx("div", __assign({ className: "dskb-count" }, { children: _jsx("p", { children: subTask.priority }) })), _jsxs("div", __assign({ style: {
                        flex: 1,
                        marginTop: 5,
                        marginBottom: 5,
                        zIndex: showTimerRunning ? 1 : undefined,
                    } }, { children: [_jsx("a", __assign({ id: "subtask-item-".concat(subTask.name), className: classNames('name-property', (subTask.inapplicable || subTask.rejected) && 'strike'), onClick: function () { return openTaskDetails(subTask); } }, { children: (_d = subTask.name) !== null && _d !== void 0 ? _d : formatListValue({
                                list: 'tasktemplate',
                                id: subTask.templateId,
                                intl: intl,
                                fallback: subTask.templateName,
                            }) })), _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx("i", { className: "fa fa-calendar", style: { marginRight: 5 } }), subTask.status !== 2 ? (_jsx(EditableDatePicker, { showClearDate: true, value: subTask.deadline ? moment.utc(subTask.deadline) : null, nullDisplayValue: intl.formatMessage(taskMessages.NoDeadline), onChange: function (deadline) { return onUpdateDeadline(deadline); }, readOnly: !canUpdateTask })) : subTask.deadline ? (_jsx(FormattedDateShort, { value: moment.utc(subTask.deadline).toDate() })) : (_jsx("span", { children: intl.formatMessage(taskMessages.NoDeadline) })), state.status === 2 && subTask.completedDate && (_jsxs(_Fragment, { children: [_jsx("i", { className: "fa fa-check", style: { marginRight: 5, marginLeft: 10 } }), _jsx("span", { children: intl.formatDate(subTask.completedDate) })] }))] }))] })), _jsxs("div", __assign({ style: {
                        display: 'flex',
                        flexDirection: 'column',
                        margin: 5,
                        zIndex: showTimerRunning ? 1 : undefined,
                    } }, { children: [_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' } }, { children: [subTask.isBlocked && (_jsx("i", { className: "fa fa-minus-circle text-danger blocked-icon", title: intl.formatMessage(taskMessages.Blocked), style: { marginRight: 7 } })), hasTaskflowBilling ? (_jsx("span", __assign({ style: { marginRight: 7 } }, { children: _jsx("i", { className: "fa fa-euro text-danger", title: intl.formatMessage(taskMessages.SubtaskWithTaskflowBilling) }) }))) : null, subTask.hasAttachments && (_jsx("span", __assign({ style: { marginRight: 7, marginTop: '4px' } }, { children: _jsx(PopoverStickOnHover, __assign({ trigger: ['hover', 'focus'], placement: "top", component: _jsx(TaskAttachmentsPopover, { attachments: attachments, loadingAttachments: loadingAttachments }), shouldUpdatePosition: true, onMouseEnter: retrieveAttachments, onClick: function () { return openTaskDetails(subTask); } }, { children: _jsx("span", { children: _jsx(PaperclipIcon, {}) }) })) }))), subTask.hasRemark && (_jsx("span", __assign({ style: { marginRight: 7, marginTop: '4px' } }, { children: _jsx(PopoverStickOnHover, __assign({ trigger: ['hover', 'focus'], placement: "top", component: remarkPopover, shouldUpdatePosition: true, onMouseEnter: retrieveRemark, onClick: function () { return openTaskDetails(subTask); } }, { children: _jsx("span", { children: _jsx(CommentIcon, {}) }) })) }))), ((subTask.type !== 2 && defaultCompany.taskTimeRegistrationMethod !== 2) ||
                                    (subTask.type !== 2 &&
                                        defaultCompany.taskTimeRegistrationMethod === 2 &&
                                        state.status === 2)) &&
                                    !isTimerRunning && (_jsx("a", __assign({ onClick: function () { return !isDisabled && openTimeRegistrationDialog(subTask); }, style: { marginRight: 7 } }, { children: _jsx("i", { className: "fa fa-clock-o", title: intl.formatMessage(taskMessages.CreateTimeRegistration) }) }))), subTask.type !== 3 &&
                                    subTask.type !== 4 &&
                                    subTask.type !== 1 &&
                                    (isTimerRunning ||
                                        (state.status === 1 && defaultCompany.taskTimeRegistrationMethod === 2)) && (_jsx("a", __assign({ onClick: onStartStopTimer, style: { marginRight: 7 } }, { children: isTimerRunning ? (_jsx("i", { className: "fa fa-pause-circle", title: intl.formatMessage(taskMessages.PauseTimer) })) : (_jsx("i", { className: "fa fa-play-circle", title: intl.formatMessage(taskMessages.StartTimer) })) }))), subTask.hasDocumentation && (_jsx("span", __assign({ style: { marginRight: 7 } }, { children: _jsx(PopoverStickOnHover, __assign({ trigger: ['hover', 'focus'], placement: state.status === 2 ? 'left' : 'bottom', component: documentationPopover, shouldUpdatePosition: true, onMouseEnter: retrieveDocumentation, onClick: function () { return openTaskDetails(subTask); } }, { children: _jsx("i", { className: "fa fa-book" }) })) }))), getTaskTypeIcon(), (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) > 0 && (_jsx("div", __assign({ style: { display: 'flex', marginLeft: 7 } }, { children: _jsx(TaskDropdownButton, { disabled: false, menuItems: menuItems }) })))] })), _jsx("div", __assign({ style: { flex: 1 } }, { children: _jsx(EditableUserSearch, { onChange: function (user) { return onChangeUser(user); }, value: selectedUser, className: classNames('bold-text', !subTask.userId && 'italic-text'), submitOnChange: true, withUnassigned: true, unassignedId: null }) }))] }))] })) }), "".concat(task.id).concat(subTask.id).concat(isTimerRunning)));
};
export default SubTaskComponent;
